



















module.exports =
  name: 'transaction_current_popover_save_button'
  data: ->
    dialogVisible: false
    loading: false
  props: ['transaction', 'formValid', 'mode']
  components:
    updated_accounts: require('./updated_accounts.vue').default
  computed:
    button_label:   ->
      action = if @mode == 'enter' then @$t('Enter') else @$t('Plan')
      return "#{action} #{@$t('income')}"   if @transaction.isIncome()
      return "#{action} #{@$t('expense')}"  if @transaction.isExpense()
      return "#{action} #{@$t('transfer')}" if @transaction.isTransfer()
    button_class:   ->
      ar = []
      ar.push 'is-loading' if @loading
      ar.push 'tr-income' if @transaction.isIncome()
      ar.push 'tr-expense'  if @transaction.isExpense()
      ar.push 'tr-accounts-transfer' if @transaction.isTransferBetweenAccounts()
      ar.push 'tr-virtuals-transfer' if @transaction.isTransferBetweenVirtuals()
      return ar.join(' ')
  mounted: ->
    $(document).off('keydown.save_transaction').on 'keydown.save_transaction', (e) =>
      ctrl_enter = e.keyCode == 13 and e.ctrlKey
      allowed    = $('textarea[name=description]').is(':focus') || !$('select, input').is(':focus') # IMPORTANT: otherwise form will be submitted twice, on enter in inputes and ctrl + enter
      if ctrl_enter and allowed and @formValid and $('#current_transaction_popover').length > 0
        @save()
  methods:
    save: ->
      if @mode == 'plan' && @transaction.planned_repeat_days > 0 && @transaction.id
        @dialogVisible = true
      else
        @dispatchEvent(true)

    dispatchEvent: (change_future_trs) ->
      @dialogVisible = false
      opts = { transaction: @transaction, mode: @mode, user: @$store.state.user }
      opts.change_future_trs = change_future_trs
      @loading = true
      @$store.dispatch('saveTransaction', opts).then (res) =>
        HM.track 'transaction-save', { mode: @mode, subtype: @transaction.subtype }
        @loading = false
        @$emit 'hide'
        if HM.store.state.ui.accounts_virtuals_changed_tooltip.length > 0
          @$notify
            message: @$createElement('updated_accounts')
            duration: 3000
